import { render, staticRenderFns } from "./volume-extend.vue?vue&type=template&id=92cee712&scoped=true&"
import script from "./volume-extend.vue?vue&type=script&lang=js&"
export * from "./volume-extend.vue?vue&type=script&lang=js&"
import style0 from "./volume-extend.vue?vue&type=style&index=0&id=92cee712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cee712",
  null
  
)

export default component.exports